import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/Facebook.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/Instagram.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/TikTok.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/Twitter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/vsts/work/1/s/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/culture/ShowsForCulture.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/framework/ArticleTitle.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/app/(web)/kulturprogram/[kulnr]/Kulturarrangement.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/images/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/MailchimpSignupForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/MailchimpSignupFormWithUrl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/ShowtimeAnalyticsSignupForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/YouTube.tsx");
